module.exports = __webpack_public_path__ + "img/youtube.9328ea86.png";